import React, {
    useRef,
    memo,
    useCallback,
    useState,
    useEffect,
} from 'react';
import {
    Card,
    CardContent,
    CardHeader,
    CardMedia,
    CardActions,
    CardActionArea,
    Button,
    IconButton,
    Typography,
    makeStyles,
    Link,
    MobileStepper
} from '@material-ui/core';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import LaunchIcon from '@material-ui/icons/Launch';
import NextIcon from '@material-ui/icons/ArrowForwardIos';
import BackIcon from '@material-ui/icons/ArrowBackIos';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import FeedListItemLink from "./FeedListItemLink";
import styled from "styled-components";

// uri scheme https://app.urlgeni.us

const StyledFacebookIcon = styled(FacebookIcon)`
    color: #1877f2;
`;
const StyledTwitterIcon = styled(TwitterIcon)`
    color: #1da1f2;
`;
const StyledInstagramIcon = styled(InstagramIcon)`
    color: #c32aa3;
`;
const StyledYouTubeIcon = styled(YouTubeIcon)`
    color: #ff0000;
`;
const StyledLinkedInIcon = styled(LinkedInIcon)`
    color: #007bb5;
`;

const StyledAnnouncementIcon = styled(AnnouncementIcon)`
  color: #D45D00;
`;

const networks: any = {
    1:{
        title: 'Twitter',
        icon: <StyledTwitterIcon />,
        plainIcon: <TwitterIcon  />,
        iconColor: '#1da1f2',
        userScheme: 'twitter://user?screen_name=',
        postScheme: 'twitter://status?id=',
        activated: true,
        selected: true,
    },
    2:{
        title: 'Instagram',
        icon: <StyledInstagramIcon />,
        plainIcon: <InstagramIcon  />,
        iconColor: '#c32aa3',
        userScheme: 'instagram://user?username=',
        postScheme: 'instagram://media?id=',
        activated: true,
        selected: true,
    },
    3:{
        title: 'Facebook',
        icon: <StyledFacebookIcon />,
        plainIcon: <FacebookIcon  />,
        iconColor: '#1877f2',
        userScheme: 'fb://page/?id=',
        postScheme: 'https://www.facebook.com/ManhattanCollegeEdu/posts/',
        activated: true,
        selected: true,
    },
    8:{
        title: 'YouTube',
        icon: <StyledYouTubeIcon/>,
        plainIcon: <YouTubeIcon  />,
        iconColor: '#ff0000',
        userScheme: 'youtube://www.youtube.com/user/',
        postScheme: 'youtube://www.youtube.com/watch?v=',
        activated: true,
        selected: true,
    },
    10:{
        title: 'RSS',
        icon: <StyledAnnouncementIcon />,
        plainIcon: <AnnouncementIcon  />,
        iconColor: '#D45D00',
        activated: true,
        selected: true,
        },
    11:{
        title: 'LinkedIn',
        icon: <StyledLinkedInIcon/>,
        plainIcon: <LinkedInIcon  />,
        iconColor: '#007bb5',
        userScheme: 'linkedin://school/manhattan-college/',
        postScheme: 'linkedin://posts/',
        activated: true,
        selected: true,
    },
};

const request = require('request');

export const FeedListItem = memo((props: any) => {
        const {source, post} = props;
        const {
            is_repost,
            network_id,
            has_media,
            source_created_at,
            source_identifier,
            user_full_name,
            user_screen_name,
            text,
            has_video,
            url,
            user_url,
            originator_user_screenname,
            originator_user_url,
            originator_post_url,
            image,
            video,
            video_width,
            video_height,
            images,
            data,

        } = post;
    const slider = useRef()
    const [sliderIndex, setIndex] = useState(0);

        const getTitle = () => {

            if (networks[network_id].title == 'RSS')
                return source.name;

            return is_repost ? originator_user_screenname : user_full_name;

        };

        const getTitleURL = () => {

            return is_repost ? originator_user_url : user_url;
        };

        const determineMediaType = () => {

            if (has_video)
                return networks[network_id].title == 'YouTube'? 'iframe': 'video';
            if (images.length > 0 || image)
                return 'img';
            return 'div'

        };

        const determineMedia = () => {
            switch (determineMediaType()) {
                case 'video':
                case 'iframe':
                    return [{url: video}];
                case 'img':
                    let finalImages: any[] = (images.length > 0) ? images : [{url: image}];
                    return [...finalImages];
                default:
                    return [{url: ''}]
            }
        }

        const dataFilter = useCallback( (type: string) => {
            return data.filter((dataObj: any) => {
                return dataObj.name == type
            })
        }, []);





    const titleData = dataFilter('title');
    const linkData = dataFilter('link');
    const classes = useStyles();
    const date = new Date(source_created_at.replace(' ', 'T'));
    const timeString = date.toLocaleTimeString().split(' ');
    const time = timeString[0].substring(0, timeString[0].length - 3) + ' ' + timeString[1];
    const escapeLink = (text: string, url: string) => {
        return text.replace(url,`${<Link href={url} />}`)
    }
    const buttonOnClick = () => {
        const network = networks[network_id];
        const mainURL = is_repost == 1 ? originator_post_url  : url;

        let message: any = {
            url: mainURL,
            refresh: false,
        };


        if (network.title != 'RSS') {
            let urlScheme: string = network.postScheme + source_identifier;

            message = {...message, urlScheme}
        }

        if (window.webkit) {
            //@ts-ignore
            window.webkit.messageHandlers.url.postMessage(message)
        } else {
            window.open(mainURL)
        }
    }

    const headerOnClick = () => {
        const network = networks[network_id];
        const mainURL = is_repost == 1 ? originator_user_url  : user_url;

        let message: any = {
            url: mainURL,
            refresh: false,
        }

        if (network.title != 'RSS') {
            let urlScheme: string = network.userScheme;

            switch (network.title) {
                case 'YouTube':
                    urlScheme = 'youtube://' + user_url.replace('https://', '');
                    break;
                default:
                    urlScheme = urlScheme + (is_repost ? originator_user_screenname : user_screen_name);
                    break;

            }
            message = {...message, urlScheme}
        }


        if (window.webkit) {
            //@ts-ignore
            window.webkit.messageHandlers.url.postMessage(message)
        } else {
            window.open(mainURL)
        }
    }

    return (
        <Card
            variant={'outlined'}
            raised={false}

        >
            <CardActionArea
                onClick={headerOnClick}
            >
            <CardHeader
                title={getTitle()}
                subheader={date.toDateString() + ' ' + time}
                avatar={networks[network_id].icon}
            />
            </CardActionArea>

                <Slider
                    infinite={true}
                    swipe={false}
                    ref={slider}
                   afterChange={(index:number) => setIndex(index)}

                >
                    {
                        determineMedia().map((media: any) =>
                            <div  key={media.url} className={classes.mediaContainer}>
                            <CardMedia

                                poster={image}
                                component={determineMediaType()}
                                src={media.url.includes('https') ? media.url : media.url.replace('http', 'https')}
                                type={determineMediaType() == 'video' ? "video/mp4" : ''}
                                controls
                                title={getTitle()}
                                className={classes.media}
                            />
                            </div>
                        )
                    }
                </Slider>
            {determineMediaType() == 'img' && determineMedia().length > 1 &&
            <MobileStepper
                variant={'dots'}
                backButton={
                    <IconButton
                        onClick={() => {slider.current.slickPrev()}}
                    >
                        <BackIcon/>
                    </IconButton>
                }
                nextButton={
                    <IconButton
                        onClick={() => {slider.current.slickNext()}}
                    >
                        <NextIcon/>
                    </IconButton>
                }
                steps={determineMedia().length}
                activeStep={sliderIndex}
                className={classes.stepper}

            />}
            <CardContent>


                <Typography component={'h3'} variant={'h5'}>
                        <div dangerouslySetInnerHTML={markup(titleData.length > 0 ? titleData[0].value : '')} />
                    </Typography>
                    <p dangerouslySetInnerHTML={markup(text)} />
                {linkData.length == 1 &&
                <FeedListItemLink url={linkData[0].value}/>
                }
            </CardContent>

            <CardActions>
                <IconButton
                    onClick={buttonOnClick}
                    ><LaunchIcon/></IconButton>
            </CardActions>
        </Card>
    )

});

const markup = (text:string) => {
    return {__html: text }
};

const removeLinks = () => {
    let expression = /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w\-]*)?(\?[^\s]*)?/gi;
};

const useStyles = makeStyles({

    stepper: {
        position: 'relative',
        background: 'white',
        paddingLeft: 16,
        paddingRight: 16,

    },
    media: {
        borderRadius: 8,
    },
    mediaContainer: {
        paddingRight: 16,
        paddingLeft: 16
    }
});